import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const alertsClient = createApiClient(
  actions["exd-storyteller-ai/alerts"],
);

export const fetchAlerts = async (options = {}) => {
  const response = await alertsClient.get("", {}, options);

  if (!response.ok) {
    throw new Error("Failed to fetch alerts", { cause: response });
  }

  return response.data?.alerts ?? [];
};
